<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex>{{ isEditMode ? 'Update' : 'Configure' }} Volume Allocation</span>
	<span fxFlex="10" fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">
			close
		</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div class="m-t-1">
		<p class="font-size-14 m-b-0-5">
			Configure volume allocation for <strong>{{ carrierBusinessName }}</strong>
		</p>
		<p class="font-size-12 label-text-light m-b-1">
			Guarantees this carrier a specific percentage or number of loads before the waterfall begins.
			<a class="cursor-pointer primary-text" (click)="showExplanation = !showExplanation">
				{{ showExplanation ? 'Show less' : 'Learn more' }}
			</a>
		</p>
		<p *ngIf="showExplanation" class="font-size-12 label-text-light m-b-1 explanation-text">
			When a load matches this project, the allocated carrier will have a window to accept before other carriers in the waterfall are notified.
			If they don't respond within the allocation window, the load will proceed to the normal waterfall tendering process.
		</p>

		<form [formGroup]="allocationForm" class="full-width">
			<div fxLayout="row" fxLayoutGap="1rem" class="m-t-1">
				<mat-form-field fxFlex class="full-width">
					<mat-label>Allocation Type</mat-label>
					<mat-select formControlName="allocationType">
						<mat-option *ngFor="let type of allocationTypes" [value]="type.value">
							{{ type.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div fxLayout="row" fxLayoutGap="1rem" class="m-t-0-5">
				<mat-form-field fxFlex class="full-width">
					<mat-label>Allocation Value</mat-label>
					<input
						matInput
						type="number"
						formControlName="allocationValue"
						min="1"
						[max]="allocationForm.get('allocationType').value === 'PERCENTAGE' ? 100 : null"
					/>
					<span matSuffix class="font-size-12 label-text-light">{{ allocationTypeLabel }}</span>
					<mat-hint>{{ valueHint }}</mat-hint>
					<mat-error *ngIf="allocationForm.get('allocationValue').hasError('required')">
						Value is required
					</mat-error>
					<mat-error *ngIf="allocationForm.get('allocationValue').hasError('min')">
						Value must be at least 1
					</mat-error>
					<mat-error *ngIf="allocationForm.get('allocationValue').hasError('max')">
						Percentage cannot exceed 100
					</mat-error>
				</mat-form-field>
			</div>

			<div fxLayout="row" fxLayoutGap="1rem" class="m-t-0-5">
				<mat-form-field fxFlex class="full-width">
					<mat-label>Allocation Period</mat-label>
					<mat-select formControlName="allocationPeriod">
						<mat-option *ngFor="let period of allocationPeriods" [value]="period.value">
							{{ period.label }}
						</mat-option>
					</mat-select>
					<mat-hint>How often the allocation resets</mat-hint>
				</mat-form-field>
			</div>

			<div fxLayout="row" fxLayoutGap="1rem" class="m-t-0-5">
				<mat-form-field fxFlex class="full-width">
					<mat-label>Allocation Window</mat-label>
					<mat-select formControlName="allocationWindowMinutes">
						<mat-option *ngFor="let window of allocationWindowOptions" [value]="window.value">
							{{ window.label }}
						</mat-option>
					</mat-select>
					<mat-hint>Time the carrier has to accept an allocated load</mat-hint>
				</mat-form-field>
			</div>

			<!-- CN-8662: optional effective window. Outside it the allocation is skipped. -->
			<div fxLayout="row" fxLayoutGap="1rem" class="m-t-0-5">
				<mat-form-field fxFlex class="full-width">
					<mat-label>Effective Start (optional)</mat-label>
					<input
						(click)="startPicker.open()"
						[formControl]="$any(allocationForm.get('effectiveStartDate'))"
						[matDatepicker]="startPicker"
						[min]="minEffectiveDate"
						autocomplete="off"
						matInput
					/>
					<mat-datepicker-toggle [for]="startPicker" matSuffix tabIndex="-1"></mat-datepicker-toggle>
					<mat-datepicker #startPicker></mat-datepicker>
					<mat-hint>Optional — when the window begins</mat-hint>
				</mat-form-field>

				<mat-form-field fxFlex class="full-width">
					<mat-label>Effective End (optional)</mat-label>
					<input
						(click)="endPicker.open()"
						[formControl]="$any(allocationForm.get('effectiveEndDate'))"
						[matDatepicker]="endPicker"
						[min]="allocationForm.get('effectiveStartDate').value || minEffectiveDate"
						autocomplete="off"
						matInput
					/>
					<mat-datepicker-toggle [for]="endPicker" matSuffix tabIndex="-1"></mat-datepicker-toggle>
					<mat-datepicker #endPicker></mat-datepicker>
					<mat-hint>Optional — when it ends</mat-hint>
					<mat-error *ngIf="allocationForm.get('effectiveEndDate').hasError('beforeStart')">
						End date must be on or after the start date
					</mat-error>
				</mat-form-field>
			</div>

			<div fxLayout="row" class="m-t-1" *ngIf="isEditMode">
				<mat-checkbox formControlName="isActive" color="primary">
					Allocation is active
				</mat-checkbox>
			</div>
		</form>
	</div>
</mat-dialog-content>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex fxLayoutAlign="end end" fxLayoutGap="0.5rem">
		<button (click)="closeDialog()" mat-stroked-button color="primary">
			Cancel
		</button>
		<button
			(click)="submitForm()"
			mat-raised-button
			color="primary"
			[disabled]="isFormSubmitted || allocationForm.invalid"
		>
			{{ isEditMode ? 'Update' : 'Save' }} Allocation
		</button>
	</div>
</mat-dialog-actions>
